import { Badge, Box, Flex } from '@chakra-ui/react';
import { Contract } from 'shared/models/contract';
import { getBadgeVariant } from './ContractStatusBadge.types';

interface ContractServiceBadgeProps {
  contract: Contract;
  loading?: boolean;
}
const ContractStatusBadge = ({
  contract,
  loading,
}: ContractServiceBadgeProps) => {
  const variant = getBadgeVariant(contract);
  return (
    <Badge
      variant={loading ? 'loading' : String(variant.badgeVariant)}
      h={loading ? '32.5px' : ''}
    >
      <Flex gap="2" align="center">
        {!loading && (
          <Box w="10px" h="10px" borderRadius="100px" bg={variant.dotColor} />
        )}
        {variant.label}
      </Flex>
    </Badge>
  );
};
export default ContractStatusBadge;
